//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'FussFreeLicensing2026',
  data() {
    return {
      faCheck,
      socialMediaIconsDesktopPath: '/img/subscribe/rf-license-light-desktop.260525.png',
      socialMediaIconsMobilePath: '/img/subscribe/rf-license-light-mobile.260525.png',
      socialMediaIconsMobileDarkPath: '/img/subscribe/rf-license-dark-mobile.260525.png',
      socialMediaIconsDesktopDarkPath: '/img/subscribe/rf-license-dark-desktop.260525.png',
      list: [
        this.$t('subscribe.licensing_2026_tag_client_projects'),
        this.$t('subscribe.licensing_2026_tag_platform_coverage'),
        this.$t('subscribe.licensing_2026_tag_no_extra_fees'),
      ],
    };
  },
  computed: {
    ...mapState({
      uiMode: state => state.user.preferences.ui.mode,
    }),
  },
};
